import React from "react";
import { useParams } from "react-router-dom";
import ItineraryCard from "./ItineraryCard";
import { itineraryDetails } from "../Datas/itineraryData";



const ItineraryPage = () => {
  const { name } = useParams();
  const data = itineraryDetails[name] || [];

  return (
    <div className="itinerary-page">
      <h2 style={{ textAlign: "center", margin: "20px 0", fontSize: "xx-large" }}>
        {name.replace(/-/g, " ").toUpperCase()}
      </h2>

      <div style={{ padding: "0 5%" }}>
        {data.length > 0 ? (
          data.map((item, index) => (
            <ItineraryCard
    key={index}
    {...item}
    isLast={index === data.length - 1}   // ✅ important
  />
          ))
        ) : (
          <p>No itinerary found.</p>
        )}
      </div>
    </div>
  );
};

export default ItineraryPage;